/**
 * String#slice は UTF-16 コードユニット単位で切るため、
 * 絵文字などのサロゲートペアの途中で切れると孤立サロゲートが残り、� として表示される。
 */
export const sliceByCodePoints = (text: string, start: number, end?: number) =>
  [...text].slice(start, end).join('');
